import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  darkMode: false,
};

const themeSlice = createSlice({
  name: "themeSlice",
  initialState,
  reducers: {
    switchLight: (state) => {
      state.darkMode = false;
    },
    switchDark: (state) => {
      state.darkMode = true;
    },
  },
});

export const { switchLight, switchDark } = themeSlice.actions;

export default themeSlice.reducer;
